import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useAlert } from '@rahtab/ui/dist/components/Alert';
import { useNavigation } from '@react-navigation/core';
import { useEffect } from 'react';

export const useStartStock = (assignFinalCode: string) => {
  const { goBack } = useNavigation();
  const alert = useAlert();
  const [startStock, { loading, data, called }] = useFetchCallType<StartStockResult>('StartAssignFinallStock', {
    params: `AssignFinallCode=${assignFinalCode}`,
    skip: true,
  });
  useEffect(() => {
    if (data && !loading) {
      const { error, result: success } = data;
      if (!success)
        alert({
          title: 'پیام سیستم',
          message: error,
          severity: 'error',
          hideBackButton: true,
          notClosableByOutsidePress: true,
          buttons: [
            {
              text: 'بازگشت',
              color: 'secondary',
              variant: 'outlined',
              onPress: () => goBack(),
            },
          ],
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.result, loading]);
  return { startStock, data, loading, called };
};

export interface StartStockResult {
  result: boolean; //نتیجه شروع عرضه
  message: string;
  error: string; // خطای شروع عرضه
  wfInstanceCode: string; // جهت ارسال در مرحله ثبت عرضه
  dtc: string;
  formCode: string;
  compileDC: string; //جهت ارسال در مرحله ثبت عرضه
  wfName: string;
  stateCode: string;

  itemName: string; //نام کالایی که عرضه می شود
  remainingValue: string; //مقدار موجودی بار
  remainingMeasureName: string; //نام واحد مقدار موجودی بار
  stockMeasureCode: string; // کد واحد عرضه جهت ارسال در مرحله ثبت
  stockMeasureName: string; // نام واحد عرضه مثلا عدد
  assignPricePerUnit: string; // قیمت واحد خرید بار
  stockPricePerUnit: string; //قیمت واحد فروش کالای عرضه شده
}
